import React, { createContext, useState, useEffect, useContext } from 'react';
import { getInitialTheme, applyTheme, normalizeTheme } from '../theme';

// Ce contexte est désormais une simple façade React au-dessus de `src/theme.js`
// (source unique de vérité). Il n'applique plus le thème de son côté : il
// délègue à applyTheme() et se resynchronise sur les événements globaux.
const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(() => getInitialTheme() === 'dark');

  // Applique le thème quand l'état change (toggle via le contexte).
  useEffect(() => {
    applyTheme(isDarkMode ? 'dark' : 'light');
  }, [isDarkMode]);

  // Se resynchronise si le thème est changé ailleurs (Header, Sidebar, autre onglet).
  useEffect(() => {
    const onExternalChange = (e) => {
      const mode = normalizeTheme(e?.detail);
      if (mode) setIsDarkMode(mode === 'dark');
    };
    window.addEventListener('fm:theme-change', onExternalChange);
    return () => window.removeEventListener('fm:theme-change', onExternalChange);
  }, []);

  const toggleTheme = () => setIsDarkMode((prev) => !prev);

  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
